import React, { useState, useEffect } from 'react'

import Card from '../../../../Base/Components/Card/Card'
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid'
import { getInventario, getTomaInventarioAgrupado, getTomaInventarioDates } from '../../../../API/Mantenimiento/Inventario/InventarioRequests'
import { decimalTemplate } from '../../../../Base/Services/TemplatesServices'

import CalendarioOperativo from '../../../../Base/Components/CalendarioOperativo/CalendarioOperativo'
import { getDateProduction, setDateTimeSQL, setDateTimeSQLH } from '../../../../Base/Services/FechasService'
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService'
import { Button } from 'primereact/button'


const TomaInventarioMantenimiento = () => {


    const [date, setDate] = useState(new Date());
    const [inventario, setInventario] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [agrupar, setAgrupar] = useState(false);


    const colums = [
        {
            header: 'Codigo',
            field: 'CodigoProducto',
            Format: 'Center',
            Sumary: 'count',
            className: 'small'
        },
        {
            header: 'Producto',
            field: 'NombreProducto',
            className: 'colum-width-XXXXlarge',
        },
        {
            header: 'Mes',
            field: 'mes',
            // Format: 'Center'
            className: 'colum-width-Xsmall',
        },
        {
            header: 'Año',
            field: 'año',
            Format: 'Center',
            className: 'colum-width-Xsmall',
        },
        {
            header: 'Fecha',
            field: 'fechaInventario',
            Format: 'Date',
            className: 'colum-width-small',
            hidden: !agrupar,
        },

        {
            header: 'Inv. Sistema',
            field: 'InventarioSistema',
            Format: 'Decimal',
            className: 'colum-width-small',
            Sumary: 'sum',
            // hidden: !agrupar,
        },
        {
            header: 'Inv. Fisico',
            field: 'inventario',
            Format: 'Decimal',
            className: 'colum-width-small',
            Sumary: 'sum',
        },
        {
            header: 'DIFF',
            field: 'Balance',
            className: 'colum-width-small',
            Format: 'Currency',
            Sumary: 'sum',
            // cellClass: 'ag-rows-red'
            cellStyle: params => {
                // console.log(params);
                if (params.value !== 0 && params.data?.NombreProducto) {
                    return {
                        color: 'rgba(234, 90, 107, 1)',
                        fontSize: '1.1rem', fontWeight: 'bold'
                    };
                }
                return null;
            }
        },
        {
            field: 'userInve',
            header: 'Usuario',
            headerEn: '',
            className: 'Xsmall',
            hidden: !agrupar,
        },

        {
            field: 'IsDiff',
            header: '',
            headerEn: '',
            className: 'small',
            Format: 'Checkbox',
            hidden: !agrupar,
            // valueFunction: ({data}) => {
            //    console.log(data);
            //    return data?.Balance !== 0
            // }

        },

    ]

    const rowClassRules = {

        'ag-columns-red': (params) => {
            return params.data.Balance !== 0 && params.data.NombreProducto
        },
    };

    const table = {
        Data: inventario,
        Columns: colums,
        loading: loading,
        // showEditMenu: true,
        // showEditMenuCSV: true,
        // showEditMenuCustom: <EditMenuCustom />
        // rowClassRules: rowClassRules,
    }

    const obtenerInventario = async () => {
        setLoading(true)
        // console.log();
        let fechas = getDateProduction(dates)
        const t = await getTomaInventarioDates({ FechaInicio: fechas[0], FechaFin: fechas[1] });
        console.log({ t });
        if (t) {
            setInventario(t)
        }
        console.log('asdfasdf');
        setLoading(false)
    }

    const agruparInformacion = async () => {
        if (!agrupar) {
            setLoading(true)
            const result = await getTomaInventarioAgrupado(getDateProduction(dates), 1)
            setInventario(result)
            setLoading(false)
        } else {
            obtenerInventario()
        }
        setAgrupar(!agrupar)
    }


    useEffect(() => {
        if (date.length > 0) {
            obtenerInventario();
        }
    }, [date])

    useEffect(() => {
        setTitlePage('Toma Inventario')
    }, [])


    return (
        <div>
            <Card
                titulo={<div className='my-2 d-flex'>
                    <div className="p-float-label ">
                        <CalendarioOperativo
                            getInfo={obtenerInventario}
                            dates={dates}
                            setDates={setDates}
                        />
                    </div>
                    <Button icon='ri-voice-recognition-line' label={agrupar ? 'Desagrupar' : 'Agrupar'} style={{ height: 35 }} onClick={() => agruparInformacion(agrupar)} />
                </div>}
                contenido={<div className='pt-4 my-2' style={{ height: '80vh' }}>
                    <div style={{ height: '80vh' }}>
                        <AgGrid table={table} />
                    </div>
                </div>}
            />
        </div>

    )
}

export default TomaInventarioMantenimiento